import moment from 'moment';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import selectors from '../../store/selectors';
import { useFetchAccountOptions } from '../../api/actions/useFetchAccountOptions';

export const useIsPastoralVisitActiveAndAvailable = () => {
  const isFetchingAccountOptions = useFetchAccountOptions();

  const activePeriod = useSelector(selectors.selectPastoralVisitActivePeriod);
  const isAvailable = useSelector(selectors.selectPastoralVisitFeatureFlag);

  return useMemo(() => {
    if (isFetchingAccountOptions) {
      return false;
    }

    const now = moment();
    const from = moment(activePeriod?.from).startOf('day');
    const to = moment(activePeriod?.to).startOf('day');
    return now.isBetween(from, to) && !!isAvailable;
  }, [isFetchingAccountOptions, activePeriod, isAvailable]);
};
